import React, { useState, useEffect } from "react";
import moment from 'moment'
// react plugin for creating charts
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import { Divider, Select, InputLabel, MenuItem, FormControl, Typography, ListItem, List, ListItemSecondaryAction, ListItemText, ListItemAvatar, Checkbox, Avatar, Tooltip, IconButton, TextField, Table, TableBody, Grid, TableRow } from "@material-ui/core";

// @material-ui/icons
import DateRange from "@material-ui/icons/DateRange";
import FlagIcon from '@material-ui/icons/Flag';

import CreateIcon from '@material-ui/icons/Create';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import MyLocationIcon from '@material-ui/icons/MyLocation';
// core components
import GridItem from "../components/Grid/GridItem.js";
import GridContainer from "../components/Grid/GridContainer.js";
import Dialog from "../components/Dialog/Dialog.js";
import Card from "../components/Card/Card.js";
import CardHeader from "../components/Card/CardHeader.js";
import CardIcon from "../components/Card/CardIcon.js";
import CardFooter from "../components/Card/CardFooter.js";
import ButtonFloating from "../components/CustomButtons/ButtonFloating.js";
import styles from "../assets/jss/material-dashboard-react/views/dashboardStyle.js";
import stylesAdmin from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";
import Navbar from "../components/Navbars/Navbar.js";
import Footer from "../components/Footer/Footer.js";

//Funtions
import { Empty, validateInputs, mostrarError, crear_form_data, formulario, consulta, Toast, colorDinamic, iconoDinamic, getError } from '../funciones/general';

const useStyles = makeStyles(styles);
const useStylesAdmin = makeStyles(stylesAdmin);

function ListService({ servicios, addServiceCategory, removeServiceCategory }) {
  const classes = useStyles();

  const handleToggle = (value, idPermiso) => () => {
    if (!idPermiso) addServiceCategory(value);
    else removeServiceCategory(idPermiso);
  };

  return (
    <List dense className={classes.rootList}>
      {servicios.map(({ id, nombre, permiso }) => {
        const labelId = `checkbox-list-primary-label-${id}`;
        return (
          <>
            <ListItem key={id} button className={classes.itemList}>
              <ListItemAvatar>
                <Avatar style={{ background: permiso ? '#009688' : '#b71c1c', color: 'white' }}>{nombre.charAt(0)}</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      {nombre}
                    </Typography>
                  </React.Fragment>
                }
              />
              <ListItemSecondaryAction>
                <Checkbox
                  edge="end"
                  onChange={handleToggle(id, permiso)}
                  checked={permiso ? true : false}
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemSecondaryAction>
            </ListItem>
            <Divider variant="inset" component="li" />
          </>
        );
      })}
    </List>
  );
}

function DetailService({ data }) {
  const classes = useStyles();

  let {
    nombre,
    descripcion,
    valorc,
    valord,
    fecha_registro,
    usuario_registro,
    estado
  } = data;
  let fecha = moment(fecha_registro).format('YYYY-MM-DD, h:mm a');
  return (

    <Table>
      <TableBody>
        <TableRow key={6}>
          <Grid container className={classes.tableRow}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowTitle}>Tipo</Grid>
            <Grid align="left" item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowVal}>{valord == '' || valord == 'principal' ? 'Principal' : 'Subcategoría'}</Grid>
          </Grid>
        </TableRow>
        <TableRow key={1}>
          <Grid container className={classes.tableRow}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowTitle}>Nombre</Grid>
            <Grid align="left" item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowVal}>{nombre}</Grid>
          </Grid>
        </TableRow>
        <TableRow key={2}>
          <Grid container className={classes.tableRow}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowTitle}>Descripción</Grid>
            <Grid align="left" item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowVal}>{valorc}</Grid>
          </Grid>
        </TableRow>
        <TableRow key={6}>
          <Grid container className={classes.tableRow}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowTitle}>Observación</Grid>
            <Grid align="left" item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowVal}>{descripcion}</Grid>
          </Grid>
        </TableRow>
        <TableRow key={3}>
          <Grid container className={classes.tableRow}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowTitle}>Estado Actual</Grid>
            <Grid align="left" item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowVal}>{estado == 1 ? 'Activo' : 'Inactivo'}</Grid>
          </Grid>
        </TableRow>
        <TableRow key={4}>
          <Grid container className={classes.tableRow}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowTitle}>Registrado por</Grid>
            <Grid align="left" item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowVal}>{usuario_registro && usuario_registro.usuario}</Grid>
          </Grid>
        </TableRow>
        <TableRow key={5}>
          <Grid container className={classes.tableRow}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowTitle}>Fecha Registro</Grid>
            <Grid align="left" item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.tableRowVal}>{fecha}</Grid>
          </Grid>
        </TableRow>
      </TableBody>
    </Table>
  )
}

function AddService({ nombre, setNombre, descripcion, setDescripcion, setObservacion, observacion, tipoCategoria, setTipoCategoria, errores }) {
  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">¿ Seleccione Tipo ?</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={tipoCategoria}
                  onChange={({ target: { value } }) => setTipoCategoria(value)}
                >
                  <MenuItem value={"principal"}>Principal</MenuItem>
                  <MenuItem value={"subcategoria"}>Subcategoría</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>
          <br />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <TextField
                onChange={({ target: { value } }) => setNombre(value)}
                value={nombre}
                error={getError('nombre', errores) && true}
                helperText={getError('nombre', errores)}
                label="Nombre"
                fullWidth={true}
                required
              />
            </GridItem>
          </GridContainer>
          <br />
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <TextField
                onChange={({ target: { value } }) => setObservacion(value)}
                value={observacion}
                label="Descripción"
                fullWidth={true}
              />
            </GridItem>
          </GridContainer>
          <br />
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <TextField
                onChange={({ target: { value } }) => setDescripcion(value)}
                value={descripcion}
                label="Observación"
                fullWidth={true}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}


function ShowData({ data, setTipoCategoria, setDataSele, updateValueGenerica, setModalAdd, setObservacion, setNombre, setDescripcion, setTipo, setErrores, setModalDetail, setModalAddService, getServices }) {
  const classes = useStyles();

  const showDataUpdate = (e) => {
    setModalAdd(true);
    setDataSele(e);
    setNombre(e.nombre);
    setDescripcion(e.descripcion);
    setObservacion(e.valorc);
    setTipoCategoria(e.valord);
    setTipo('update');
    setErrores([]);
  }


  return (
    data.map(e => {
      let iconoD = iconoDinamic(parseInt(e.valorb));
      return (
        <GridItem
          xs={12}
          sm={6}
          md={3}
        >
          <Card className={classes.cardItem}
            onClick={() => {
              setDataSele(e);
              setModalDetail(true)
            }}
          >
            <CardHeader color={e.valora} stats icon>
              <CardIcon color={e.valora}>
                {iconoD.icon()}
              </CardIcon>
              <p className={classes.cardCategory}>
                {e.nombre.slice(0, 16).toUpperCase()}
                {e.nombre.length > 16 ? ' ...' : ''}
              </p>
              <h4 className={classes.cardTitle}>
                <small>
                  {e.valord == '' || e.valord == 'principal' ? 'Principal' : 'Subcategoría'}
                </small>
              </h4>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats} style={{ textAlign: 'left' }}>
                <FlagIcon />
                {`Estado : ${e.estado == 1 ? 'Activo' : 'Inactivo'}`}<br />
                <DateRange />
                {`Creado el ${moment(e.fecha_registro).format('YYYY-MM-DD, h:mm a')}`}
              </div>
            </CardFooter>
          </Card>
          <div className={classes.stats}>
            {
              e.estado == 1
                ? <Tooltip className={classes.statsTolltip} style={{ backgroundColor: "#b71c1c" }} title="Desactivar" onClick={() => updateValueGenerica(e.id, { estado: 0 })}><IconButton className={classes.statsIcon}  ><VisibilityOffIcon fontSize="small" /> </IconButton></Tooltip>
                : <Tooltip className={classes.statsTolltip} style={{ backgroundColor: "#009688" }} title="Activar" onClick={() => updateValueGenerica(e.id, { estado: 1 })} ><IconButton className={classes.statsIcon}  ><VisibilityIcon fontSize="small" /> </IconButton></Tooltip>
            }
            <Tooltip className={classes.statsTolltip} style={{ backgroundColor: "#2196f3" }} title="Editar" onClick={() => showDataUpdate(e)} ><IconButton className={classes.statsIcon}><CreateIcon fontSize="small" /> </IconButton></Tooltip>
            <Tooltip className={classes.statsTolltip} style={{ backgroundColor: "#673ab7" }} title="Servicios" onClick={() => {
              setDataSele(e);
              getServices(e.id);
              setModalAddService(true);
            }} >
              <IconButton className={classes.statsIcon}><LibraryAddIcon fontSize="small" /> </IconButton></Tooltip>
            {
              e.valord == 'principal' &&
              <Tooltip className={classes.statsTolltip} style={{ backgroundColor: "#607d8b" }} title="Subcategorías" onClick={() => {
                setDataSele(e);
                getServices(e.id, 2, 'subcategoria');
                setModalAddService(true);
              }} >
                <IconButton className={classes.statsIcon}>< MyLocationIcon fontSize="small" /> </IconButton></Tooltip>
            }
          </div>
        </GridItem>
      )
    })
  )
}



export default function Category() {
  let currentUrl = window.location.pathname.split("/")[2];
  const mainPanel = React.createRef();
  const classes = useStylesAdmin();
  const [search, setSearch] = useState('');
  const [genericaFilter, setGenericaFilter] = useState({});
  const [tipo, setTipo] = useState('add');
  const [tipoCategoria, setTipoCategoria] = useState('principal');
  const [modalAdd, setModalAdd] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalAddService, setModalAddService] = useState(false);
  const [modalDetailContent, setModalDetailContent] = useState(false);
  const [wait, setWait] = useState(true);
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [observacion, setObservacion] = useState('');
  const [data, setData] = useState([]);
  const [dataContent, setDataContent] = useState([]);
  const [dataSele, setDataSele] = useState({});
  const [errores, setErrores] = useState([]);
  const [dataService, setDataService] = useState([]);

  useEffect(() => {
    getCategorys();
  }, []);

  const addValueGenerica = async (data) => {
    let errores = await validateInputs([
      { value: nombre, name: 'nombre', err: { empty: true } },
    ]);
    if (errores.length == 0) {
      setErrores([]);
      consulta("valores/crear", data, "post",
        (error, estado, resp) => {
          if (estado === 200) {
            setNombre('');
            setDescripcion('');
            setObservacion('');
            setTipoCategoria('principal');
            getCategorys(search);
            Toast.fire({ icon: 'success', title: resp.titulo });
          } else {
            let newError = errores;
            // newError.push({'llave' : 'nombre', 'mensaje' : 'Este campo es obligatorio'});
            setErrores(newError);
            Toast.fire({ icon: 'info', title: resp.titulo ? resp.titulo : mostrarError(resp) });
          }
        }
      );
    } else {
      setErrores([]);
      setErrores(errores);
    }
  }

  const updateValueGenerica = async (id, data, tipoUp = 'update') => {
    let errores = await validateInputs([
      { value: nombre, name: 'nombre', err: { empty: true } },
    ]);
    if (errores.length == 0 || tipoUp != 'update_all') {
      setErrores([]);
      data = await crear_form_data(data);
      formulario(`valores/${id}`, data, "patch",
        (error, estado, resp) => {
          if (estado === 200) {
            setNombre('');
            setDescripcion('');
            setObservacion('');
            setModalAdd(false);
            setTipo('add');
            setTipoCategoria('principal');
            getCategorys(search);
            Toast.fire({ icon: 'success', title: resp.titulo });
          } else Toast.fire({ icon: 'info', title: resp.titulo ? resp.titulo : mostrarError(resp) });

        }
      );
    } else {
      setErrores([]);
      setErrores(errores);
    }
  }


  const getCategorys = (search = '') => {
    setWait(true);
    consulta(`generica/${2}/valores?search=${search}`, null, null, (error, estado, resp) => {
      setWait(false);
      setData(resp);
    });
  };

  const getServices = (category, generica = 1, valord = '') => {
    setWait(true);
    setGenericaFilter({ generica, valord, });
    consulta(`valores/${category}/permisos?generica=${generica}&valord=${valord}`, null, null, (error, estado, resp) => {
      setWait(false);
      setDataService(resp);
    });
  };

  const addServiceCategory = (principal, secundario) => {
    consulta(`permisos/crear`, { principal, secundario }, 'post',
      (error, estado, resp) => {
        if (estado === 200) {
          getServices(principal, genericaFilter.generica, genericaFilter.valord);
          Toast.fire({ icon: 'success', title: resp.titulo });
        } else Toast.fire({ icon: 'info', title: resp.titulo ? resp.titulo : mostrarError(resp) });
      });
  };

  const removeServiceCategory = (id, principal) => {
    consulta(`permisos/${id}`, { estado: 0 }, 'patch',
      (error, estado, resp) => {
        if (estado === 200) {
          getServices(principal, genericaFilter.generica, genericaFilter.valord);
          Toast.fire({ icon: 'success', title: resp.titulo });
        } else Toast.fire({ icon: 'info', title: resp.titulo ? resp.titulo : mostrarError(resp) });
      });
  };


  return (
    <div className={classes.wrapper}>
      <div ref={mainPanel}>
        <div>
          <Navbar
            text={currentUrl}
            callbackSearch={(data) => {
              setSearch(data);
              getCategorys(data);
            }}
          />
          <div className={classes.content}>
            <div className={classes.container}>
              <div>
                {
                  data.length === 0 && <Empty />
                }
                <GridContainer>
                  <ShowData
                    data={data}
                    setDataSele={setDataSele}
                    updateValueGenerica={updateValueGenerica}
                    setModalAdd={setModalAdd}
                    setNombre={setNombre}
                    setDescripcion={setDescripcion}
                    setTipo={setTipo}
                    setTipoCategoria={setTipoCategoria}
                    setErrores={setErrores}
                    setModalDetail={setModalDetail}
                    setModalAddService={setModalAddService}
                    getServices={getServices}
                    setObservacion={setObservacion}
                  />
                </GridContainer>
                <ButtonFloating callback={() => setModalAdd(true)} />
                <Dialog
                  open={modalAdd}
                  setOpen={(modal) => {
                    if (tipo == 'update') {
                      setNombre('');
                      setDescripcion('');
                      setObservacion('');
                    }
                    setTipo('add');
                    setErrores([]);
                    setModalAdd(modal);
                  }}
                  title={`${tipo == 'add' ? 'Nueva' : 'Modificar'} Categoría`}
                  subTitle='Complete los siguientes campos'
                  children={
                    <AddService
                      errores={errores}
                      descripcion={descripcion}
                      nombre={nombre}
                      setDescripcion={setDescripcion}
                      setNombre={setNombre}
                      setObservacion={setObservacion}
                      observacion={observacion}
                      tipoCategoria={tipoCategoria}
                      setTipoCategoria={setTipoCategoria}
                    />}
                  callback={
                    handleClose => {
                      let valora = colorDinamic().color;
                      let valorb = parseInt(Math.random() * (10 - 0) + 0);
                      let valorc = observacion;
                      let valord = tipoCategoria;
                      let dataAdd = { generica: 2, nombre, valorc, descripcion, valora, valorb, valord };
                      let dataUpd = { nombre, descripcion, valorc, valord };
                      if (tipo == 'add') addValueGenerica(dataAdd, handleClose);
                      else updateValueGenerica(dataSele.id, dataUpd, 'update_all');
                      return false;
                    }}
                />

                <Dialog
                  nameBtn1=''
                  nameBtn2='CERRAR'
                  open={modalDetail}
                  setOpen={setModalDetail}
                  title={`Detalle Categoría`}
                  subTitle={''}
                  children={dataSele ? <DetailService data={dataSele} /> : <p></p>}
                // tasks={ <OpenServiceTasks /> } 
                />

                <Dialog
                  nameBtn1=''
                  nameBtn2='CERRAR'
                  open={modalAddService}
                  setOpen={setModalAddService}
                  title={`Asignar Servicio`}
                  subTitle={dataSele && dataSele.nombre}
                  children={<ListService servicios={dataService} addServiceCategory={(service) => addServiceCategory(dataSele.id, service)} removeServiceCategory={(id) => removeServiceCategory(id, dataSele.id)} />}
                // tasks={ <OpenServiceTasks /> } 
                />

              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}
